var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.55,
    height: 110.567,
    viewBox: "0 0 119.55 110.567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12848",
    "data-name": "Group 12848",
    transform: "translate(-5 34.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12845",
    "data-name": "Group 12845",
    transform: "translate(5.5 21.727)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_657",
    "data-name": "Ellipse 657",
    cx: 26.994,
    cy: 26.994,
    rx: 26.994,
    ry: 26.994,
    transform: "translate(0 0)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11119",
    "data-name": "Path 11119",
    d: "M-644.665,59.8h-1.406a1.591,1.591,0,0,1-1.635-.874c-.016-.05-.036-.1-.053-.15,0-.016-.008-.032-.008-.032h0a13.047,13.047,0,0,0-.553-1.348c0-.01,0-.017-.007-.029A1.711,1.711,0,0,1-648,55.455l.055-.055.008-.008h0l.854-.855a1.231,1.231,0,0,0,.114-1.844l-2.872-2.872a1.174,1.174,0,0,0-1.762-.076l-.073.073,0,0-1.278,1.277h0a1.2,1.2,0,0,1-1.344.167v0a13.1,13.1,0,0,0-1.38-.6.578.578,0,0,0-.146-.061A1.459,1.459,0,0,1-657,49.3V47.991a1.666,1.666,0,0,0-1.759-1.676h-3.063a1.666,1.666,0,0,0-1.759,1.676c0,.06,0,.1,0,.156v1.405c-.038.268-.219.7-.952.979a.139.139,0,0,0-.017.008,13.053,13.053,0,0,0-1.451.593c-.016.006-.027.007-.044.014a1.666,1.666,0,0,1-1.857-.322l-.873-.873,0,0a1.275,1.275,0,0,0-1.881-.212l-2.929,2.93a1.153,1.153,0,0,0-.105,1.678l0,0,1.245,1.245h0a1.626,1.626,0,0,1,.2,1.77h.005a13.126,13.126,0,0,0-.584,1.425c0,.008-.007.012-.01.021a1.516,1.516,0,0,1-1.423.99h-1.823c-.382.025-.984.172-.984.871v4.717c.029.345.224,1,1.292,1h1.49a1.48,1.48,0,0,1,1.4.861l0,0a13.042,13.042,0,0,0,.686,1.682h0l.011.015c.022.047.045.093.068.139a1.5,1.5,0,0,1-.5,1.679l0,0-1.239,1.239a.857.857,0,0,0,.015,1.258h0l3.39,3.39h0s.678.579,1.519-.26l1.181-1.181a1.528,1.528,0,0,1,1.806-.127.8.8,0,0,0,.19.079c.345.155.7.3,1.053.423l0,.005.036.007c.093.032.185.065.277.1a1.378,1.378,0,0,1,.813,1.367v1.756a1.046,1.046,0,0,0,.847,1.05h4.41A1.223,1.223,0,0,0-657,78.658v-1.68a1.554,1.554,0,0,1,1.048-1.357.177.177,0,0,0,.026-.014,12.789,12.789,0,0,0,1.23-.5c.023-.008.043-.012.068-.023a1.915,1.915,0,0,1,1.9.226l.967.967h0a1.323,1.323,0,0,0,1.919.1l.005,0,2.784-2.785h0c.719-.719.534-1.288.3-1.613l-1.291-1.291a1.436,1.436,0,0,1-.443-1.543c.055-.108.108-.217.16-.326.011-.017.019-.028.019-.028l-.006,0a13.33,13.33,0,0,0,.535-1.3c.005-.013.011-.02.016-.034a1.794,1.794,0,0,1,1.646-1.061h1.206c.319-.01,1.4-.158,1.4-1.7V61.417C-643.514,60.074-644.274,59.835-644.665,59.8Zm-15.629,8.415a5.127,5.127,0,0,1-5.12-5.122,5.127,5.127,0,0,1,5.12-5.121,5.129,5.129,0,0,1,5.125,5.121A5.129,5.129,0,0,1-660.293,68.215Z",
    transform: "translate(687.285 -36.099)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12846",
    "data-name": "Group 12846",
    transform: "translate(37.717 -33.852)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_656",
    "data-name": "Ellipse 656",
    cx: 26.994,
    cy: 26.994,
    rx: 26.994,
    ry: 26.994,
    transform: "translate(0 0)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(14.528 11.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M-547.117-79.21h-1.563c-4.774,0-11.624,3.223-11.624,8.614a2.532,2.532,0,0,0,2.244,2.79c.047,0,.095.009.143.011h20.135a2.491,2.491,0,0,0,2.394-2.584q0-.057-.007-.113v-.1C-535.395-75.987-542.245-79.21-547.117-79.21Z",
    transform: "translate(560.319 98.929)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M-538.432-117a5.878,5.878,0,0,0,4.458-1.868c2.905-2.906,2.8-8.3,2.8-8.51a7.265,7.265,0,0,0-7.265-7.265,7.265,7.265,0,0,0-7.265,7.265c0,.208-.1,5.6,2.8,8.614A6.188,6.188,0,0,0-538.432-117Z",
    transform: "translate(550.902 134.647)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12847",
    "data-name": "Group 12847",
    transform: "translate(70.062 21.727)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_655",
    "data-name": "Ellipse 655",
    cx: 26.994,
    cy: 26.994,
    rx: 26.994,
    ry: 26.994,
    transform: "translate(0 0)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12845-2",
    "data-name": "Group 12845",
    transform: "translate(10.217 12.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11120",
    "data-name": "Path 11120",
    d: "M-433.892,67.091a6.04,6.04,0,0,1-6.04,6.04h-.852l-9.885-9.885-9.885,9.885h-.852a6.04,6.04,0,0,1-6.04-6.04,6.036,6.036,0,0,1,6.04-6.04h1.939l.389-1.51a8.672,8.672,0,0,1,10.549-6.268,8.666,8.666,0,0,1,6.268,6.268l.389,1.51h1.939A6.036,6.036,0,0,1-433.892,67.091Z",
    transform: "translate(467.446 -53.002)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11121",
    "data-name": "Path 11121",
    d: "M-427.222,96.83l-2.221,2.221-4.758-4.758v10.234h-3.141V94.28l-4.765,4.765-2.221-2.221,8.549-8.549Z",
    transform: "translate(452.551 -75.728)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/trending.54e2d6f9107f06a3cd6188a3f90225c1.svg";
export { ForwardRef as ReactComponent };